import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { fetchCommunitiesFailure, fetchCommunitiesSuccess } from "domains/collection/actions";
import type { FetchCommunitiesAction } from "domains/collection/actionTypes";
import type { FetchCommunitiesResponse } from "domains/collection/types/communityResponses";

export function* fetchCommunitiesSaga({ payload: { meta, search } }: FetchCommunitiesAction) {
  try {
    const response: FetchCommunitiesResponse = yield apiFetch(`community/search/${search}`, {
      queryParams: meta,
    }) ?? { requested: search, result: [] };
    yield put(fetchCommunitiesSuccess({ ...response, meta }));
  } catch (error) {
    logger.error("[fetchCommunitiesSaga] Failed to fetch communities", error);
    yield put(fetchCommunitiesFailure());
  }
}
